import style from "../../assets/scss/sub/topBanner.module.scss";
import smallSettingIcon from "../../assets/images/mypage/small_setting_icon.svg";
import voucher_add_icon from "../../assets/images/mypage/voucher_add_icon.svg";
import docIcon from "../../assets/images/mypage/doc_icon.svg";
import couponIcon from "../../assets/images/mypage/coupon_icon.svg";
import allCouponIcon from "../../assets/images/mypage/all_coupon_icon.svg";
import counselingIcon from "../../assets/images/mypage/couneling_coupon.svg";
import kIcon from "../../assets/images/mypage/small_k_icon.svg";
import dIcon from "../../assets/images/mypage/small_d_icon.svg";
import settingDarkIcon from "../../assets/images/mypage/setting_dark_icon.svg";

import {useEffect} from "react";
import {useUserInfoGetter} from "../common/hooks/useUserInfoGetter";
import {useNavigate} from "react-router-dom";
import {useTopBannerFunctions} from "./hooks/useTopBannerFunctions";
import {useModal} from "../../hooks/hooks";
import {CountContainer} from "../common/modal/mypage/CountContainer";
import {Trans, useTranslation} from "react-i18next";

interface TopBannerProps {
  totalVoucherData: {
    organDcasVoucherCnt: number;
    organKpassVoucherCnt: number;
  };
}

export function TopBanner({totalVoucherData}: TopBannerProps) {
  const { t } = useTranslation("topBanner");

  const {openVoucherRegisterModal} = useModal();
  const {user} = useUserInfoGetter();
  const navigate = useNavigate();
  const {
    getAllCouponCount, totalCouponCount,
    getProfileList, totalTestCount,
    getCounselingVoucher, totalCounselingVoucherCount
  } = useTopBannerFunctions();

  useEffect(() => {
    getAllCouponCount().then();
    getProfileList().then();
    getCounselingVoucher().then()
  }, [getAllCouponCount, getProfileList, getCounselingVoucher]);

  const onClickVoucherRegister = () => {
    openVoucherRegisterModal();
  };

  return (
      <div className={style.myPageBanner}>
        <div className={style.topTextContainer}>
            <span className={style.greetingText}>
                <Trans t={t} i18nKey={"topBanner.greeting"}
                       components={{strong: <span className={style.strong}/>}}
                       values={{name : user?.name}}
                />
            </span>
          <div className={style.memberInfoWrapper}>
            <button className={style.memberInfoBtn} onClick={() => onClickVoucherRegister()}>
              <img src={voucher_add_icon} alt={"voucherAddIcon"}/>
              {t('topBanner.btn.externalCode.label')}
            </button>
            <button className={style.memberInfoBtn} onClick={() => navigate(`/mypage/user`)}>
              <img src={smallSettingIcon} alt={"smallSettingIcon"}/>
              {t('topBanner.btn.userInfo.label')}
            </button>
          </div>

          <div className={style.mobileIconWrapper}>
            <img className={style.mobileVoucherRegisterIcon} src={voucher_add_icon} alt="voucher"
                 onClick={() => onClickVoucherRegister()}/>
            <img className={style.mobileMemberInfoIcon} src={settingDarkIcon} alt="settings"
                 onClick={() => navigate(`/mypage/user`)}/>
          </div>
        </div>
        <div className={style.bottomTextContainer}>
          <CountContainer
              icon={docIcon}
              title={t('topBanner.desc.testCount.label')}
              count={totalTestCount}
              countUnit={t('topBanner.desc.testCount.unit')}
          />

          <CountContainer
              icon={couponIcon}
              title={t('topBanner.desc.coupon.label')}
              count={totalCouponCount}
              countUnit={t('topBanner.desc.coupon.unit')}
          />

          <CountContainer
              icon={counselingIcon}
              title={t('topBanner.desc.counseling.label')}
              count={totalCounselingVoucherCount}
              countUnit={t('topBanner.desc.counseling.unit')}
          />

          <CountContainer
              icon={allCouponIcon}
              title={t('topBanner.desc.testVoucher.label')}
              countUnit={t('topBanner.desc.testVoucher.unit')}
              subCounts={[
                {
                  icon: kIcon,
                  count: totalVoucherData?.organKpassVoucherCnt,
                },
                {
                  icon: dIcon,
                  count: totalVoucherData?.organDcasVoucherCnt,
                }
              ]}
          />
        </div>
      </div>
  );
}
